import { cn } from "@/lib/utils";
import { ArrowLeft } from "lucide-react";

export const DialogHeader = ({
  title,
  subtitle,
  centerTitle = false,
  showBackButton = false,
  onBack,
}: {
  title: string;
  subtitle?: string;
  showBackButton?: boolean;
  centerTitle?: boolean;
  onBack?: () => void;
}) => {
  return (
    <div
      className={cn(
        "relative flex flex-col gap-2 w-full",
        showBackButton || centerTitle ? "items-center" : "items-start",
      )}
    >
      {showBackButton && (
        <button
          onClick={onBack}
          className="absolute left-0 top-0 p-2 rounded-lg bg-transparent hover:bg-cede-primary/10 transition-colors text-cede-text-secondary hover:text-cede-primary cursor-pointer"
          aria-label="Back"
        >
          <ArrowLeft className="w-5 h-5" />
        </button>
      )}

      <h3 className="text-xl font-semibold text-cede-text-primary leading-[160%]">{title}</h3>

      {subtitle && <p className="text-sm text-cede-text-secondary">{subtitle}</p>}
    </div>
  );
};
